export type UsersFilter = {
  name: string;
  text: string;
  value: string;
  isActive: boolean;
};

export const initialUsersFilter: UsersFilter[] = [
  {
    name: 'email',
    text: 'Email',
    value: '',
    isActive: true,
  },

  {
    name: 'lastname',
    text: 'adminUser.surname',
    value: '',
    isActive: true,
  },

  {
    name: 'firstname',
    text: 'adminUser.firstName',
    value: '',
    isActive: true,
  },

  {
    name: 'created_at',
    text: 'adminUser.registrationDate',
    value: '',
    isActive: true,
  },

  // {
  //   name: 'phone_number',
  //   text: 'adminUser.phone',
  //   value: '',
  //   isActive: true,
  // },
];
